// Will run when DOM is loaded
$(document).ready(function() {

    // Add your methods here
    projectFunctions.navigationFunctions.init();
    projectFunctions.printDatasheetFunctions.init();
    projectFunctions.singleProductFunctions.init();
    projectFunctions.customPostGridFunctions.init();
    projectFunctions.productMobileSliderFunctions.init();
    projectFunctions.productGalleryVideoFunctions.init();
    projectFunctions.tableOfContentsFunctions.init();
    projectFunctions.faqAccordionFunctions.init();
    projectFunctions.shareCopyFunctions.init();
    projectFunctions.downloadsLagFilterFunctions.init();
    projectFunctions.productSoftHardTabsFunctions.init();
});

// Will run when the page is fully loaded - including graphics.
$(window).load(function() {

    // Add your methods here
});
